import React from 'react';
import '../styles/temperature_report.scss';
import moment from 'moment';

class TemperatureReportContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        let i = 0;
        const rangeInfo = this.props.item.range == this.props.item.duration * 60 ? null : <div>{ HC_LANG.CHL_RANGE + ": " + this.props.item.range + " " + HC_LANG.CHL_MINUTES}</div>;
        return (
            <div>
                <div className="hc-tr-header">{this.props.item.checklist_name}</div>
                <div className="hc-tr-header-container">
                    <div>{ HC_LANG.CHL_DURATION + ": " + this.props.item.duration + " " + HC_LANG.CHL_HOURS}</div>
                    {rangeInfo}
                    <div>{ HC_LANG.DUE_FILL_IN + ": " + (this.props.item.fill_in == "every|0|d" ? HC_LANG.CHL_MANUALLY : HC_GetFillInStr(this.props.item.fill_in))}</div>
                    <div>{ HC_LANG.CHL_START_TIME + ": " + moment(this.props.item.startup_time).format(" HH:mm") }</div>
                </div>
                { this.props.item.periods.map(p => <TemperatureReport key={i++} data={p} /> )}
            </div>)
    }
}
module.exports = TemperatureReportContent;


class TemperatureReport extends React.Component {
    render() {
        let i = 0;
        return (
            <div>
                <div className="hc-tr-period-header">{this.props.data.title}</div>
                <div className="hc-tr-period-container">
                    { this.props.data.items.map(p => <TemperatureQuestionItem key={i++} item={p} /> )}
                </div>
            </div>)
    }
}

class TemperatureQuestionItem extends React.Component {
    render() {
        let count = this.props.item.temp_data ? this.props.item.temp_data.length : 0;

        let timeControls = this.props.item.temp_data.map(function (td, i) {
            let convTime = moment(td.time).format(" HH:mm");
            let convVal = td.value + "°C";
            let icon;

            if (count == 1)
                icon = "public/images/trep-beg.svg";
            else
                icon = i == 0 ? "public/images/trep-beg.svg" : (
                    i == count - 1 ? "public/images/trep-end.svg" : "public/images/trep-mid.svg"
                );

            return (
                <div className="hc-tr-question-pair" key={i++}>
                    <div className="hc-tr-q-checked-time">{convTime}</div>
                    <img src={icon} />
                    <div className="hc-tr-q-checked-val">{convVal}</div>
                </div>)
        }.bind(this));

        return (
            <div className="hc-tr-question-item">
                <div className="hc-tr-question-header">{this.props.item.q_caption + " " + this.props.item.q_control_val + "°C"}</div>
                <div className="hc-tr-question-container">
                    {timeControls}
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./reports/TemperatureReport.js